import React, { useState, useEffect } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import * as Util from "../utils/util.js";

const useStyles = makeStyles((theme) => ({
  textField_ID: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  textField_PW: {
    marginBottom: theme.spacing(1),
  },

  button: {
    marginTop: theme.spacing(2),
    width: "100%",
    height: "45px",
    backgroundColor: "#5EB3D7",
    color: "#ffffff",
    "&:focus": {
      backgroundColor: "#5EB3D7",
    },
  },

  backdrop: {
    zIndex: 1252,
    color: "#fff",
  },
}));

function Sso() {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  const sessionStorage = window.sessionStorage;

  useEffect(() => {
    let userId = new URLSearchParams(location.search).get("id");
    let userPass = new URLSearchParams(location.search).get("pw");

    if (userId == undefined || userPass == undefined) {
      navigate("/", {
        replace: true,
      });
      return;
    }

    let form = new FormData();
    form.append("id", userId);
    form.append("pass", userPass);

    axios
      .post(Util.getBaseUrl() + "login/signIn", form)
      .then((response) => {
        if (response.data.code === "0") {
          if (response.data.PROGRAM.length === 0) {
            alert("프로그램 권한이 존재하지 않습니다.");
          } else {
            sessionStorage.setItem("user_id", response.data.DATA.userId);
            sessionStorage.setItem("user_name", response.data.DATA.USER_NAME);
            sessionStorage.setItem("workplace_cd", response.data.DATA.CUST_CD);
            sessionStorage.setItem(
              "workplace_nm",
              response.data.DATA.CUST_NAME
            );
            sessionStorage.setItem("tel_no", response.data.DATA.TEL_NO);
            sessionStorage.setItem("e_mail", response.data.DATA.E_MAIL);
            sessionStorage.setItem(
              "sellCustCd",
              JSON.stringify(response.data.DATA_CUSTOM)
            );
            sessionStorage.setItem(
              "program",
              JSON.stringify(response.data.PROGRAM)
            );
            navigate("/home", {
              replace: true,
              state: { program: response.data.PROGRAM },
            });
          }
        } else {
          alert(response.data.RESULT_MESSAGE);
          navigate("/", {
            replace: true,
          });
        }
      })
      .catch((e) => {
        alert(e.message);
        navigate("/", {
          replace: true,
        });
      });
  }, []);

  return (
    <div className="tab-root">
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "6px 8px",
          boxSizing: "border-box",
          backgroundColor: "rgb(233, 237, 246)",
          borderRadius: "14px",
        }}
      >
        <Backdrop className={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            textAlign: "center",
            color: "rgb(21,35,91)",
          }}
        >
          <div
            style={{
              width: "64mm",
              display: "flex",
              flexDirection: "column",
              margin: "64px auto",
            }}
          ></div>
        </div>
      </div>

      <div
        style={{
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translate(-46%, -50%)",
          fontSize: "1.7rem",
          fontWeight: "700",
          letterSpacing: "0",
        }}
      >
        로그인정보를 확인중입니다...
      </div>
      <img
        src={process.env.PUBLIC_URL + "/images/micromos.png"}
        style={{
          position: "absolute",
          top: "18px",
          left: "18px",
          width: "36mm",
          margin: "0 auto",
        }}
      />
    </div>
  );
}

export default Sso;
